import { render, staticRenderFns } from "./SelfEmployedPage.vue?vue&type=template&id=120c4623&"
import script from "./SelfEmployedPage.vue?vue&type=script&lang=js&"
export * from "./SelfEmployedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports